import type {
  PlayerPropListingResponse,
  PlayerPropMarketsResponse,
} from '~/domains/market/services/interfaces/market.types';

export function toPlayerPropSectionResponse(
  listing: PlayerPropListingResponse,
  { propType, teamId }: { propType: string; teamId?: string }
): PlayerPropMarketsResponse {
  const markets = listing.data.flatMap((group) => group.markets);

  return {
    data: [
      {
        prop_type: markets[0]?.prop_type ?? propType,
        title: markets[0]?.prop_type_display ?? '',
        team_id: teamId,
        total: listing.total,
        has_more: listing.offset + listing.data.length < listing.total,
        next_offset: listing.offset + listing.data.length,
        markets,
      },
    ],
    included: listing.included,
    status: listing.status,
  };
}

const uniqueById = <T extends { id: string }>(items: readonly T[]): T[] =>
  Array.from(new Map(items.map((item) => [item.id, item])).values());

export function appendPlayerPropSection(
  previous: PlayerPropMarketsResponse | undefined,
  next: PlayerPropMarketsResponse
): PlayerPropMarketsResponse {
  if (!previous) return next;

  const previousSection = previous.data[0];
  const nextSection = next.data[0];

  return {
    data: [{ ...nextSection, markets: [...previousSection.markets, ...nextSection.markets] }],
    included: {
      events: uniqueById([...previous.included.events, ...next.included.events]),
      teams: uniqueById([...previous.included.teams, ...next.included.teams]),
      entities: uniqueById([...previous.included.entities, ...next.included.entities]),
      sub_categories: next.included.sub_categories ?? previous.included.sub_categories,
    },
    status: next.status,
  };
}
